import React from "react";

function Canvas_Intro() {
  return (
    <div>
      <h1>Canvas_Intro Component</h1>
      <p>This is the Canvas Intro tutorial page content.</p>
    </div>
  );
}

export default Canvas_Intro;
